import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { IDownloadWithImageProps } from '../components/download-with-image/download-with-image';
import { ButtonModel } from './button-model';
import { IButtonProps } from '../components/button/button';

export class DownloadWithImageModel extends ContentItem {
  get button(): IButtonProps[] {
    const button = get(this._config, 'elements.button.value', []);
    const modeledButton = button.map((button: IButton) =>
      ButtonModel.create(button)
    );
    return modeledButton;
  }

  get image(): {
    url: string;
    description: string;
  } {
    return get(this._config, 'elements.image.value[0]', {});
  }

  get text(): string {
    return get(this._config, 'elements.text_value.value', '');
  }

  public static create(data: IDownloadWithImage): IDownloadWithImageProps {
    const { button, image, text } = new DownloadWithImageModel(data);
    return {
      image,
      button,
      text
    };
  }
}
